<template>
  <div class="relate-items h-full relative">
    <div class="flex justify-center bg-white h-full box1" v-if="emptyShow" v-loading="loading">
      <div class="text-center" style="margin-top: 188px">
        <div class="flex">
          <div @click="addTask('1')" class="inline-block">
            <div class="btn-box btn1 px-3 box-border" :class="{ 'btn-checked': btnChecked == 'relate' }" @click="btnChecked = 'relate'">
              <div>
                <div class="mb-2"><img src="~@/assets/img/add.png" width="48px"/></div>
                <div class="text-theme-black-850 text-medium mb-1 text-medium">关联问卷调查</div>
              </div>
            </div>
          </div>
          <div @click="addTask('2')" class="inline-block">
            <div class="btn-box btn2 px-9 box-border" :class="{ 'btn-checked': btnChecked == 'import' }" @click="btnChecked = 'import'">
              <div>
                <div class="mb-2"><img src="~@/assets/img/mcaf.png" width="48px"/></div>
                <div class="text-theme-black-850 text-medium mb-1 text-medium">关联明察暗访</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white p-4 box-border box1 relative" style="height: calc(100vh - 116px)" v-else>
      <div class="flex justify-end mb-4">
        <div>
          <el-button @click="addTask('1')" type="primary">关联问卷调查</el-button>
          <el-button @click="addTask('2')" type="primary" style="margin-left: 16px;">关联明察暗访</el-button>
        </div>
      </div>
      <div class="box2 mb-4">
        <div class="flex justify-between p-4 border border-d8 border-solid mb-4" v-for="(row, idx) in tableData" :key="idx">
          <div>
            <div class="mb-3">
              <div
                class="inline-block relative -top-px"
                :style="{
                  'background-color': {
                    0: 'rgba(39, 117, 232, 0.15)',
                    1: 'rgba(232, 163, 27, 0.15)',
                    2: 'rgba(232, 163, 27, 0.15)',
                    3: 'rgba(232, 163, 27, 0.15)'
                  }[row.subProjectCategory],
                  padding: '0px 6px',
                  'line-height': '19px'}">
                <span
                  class="font-semibold text-small"
                  :style="`color: ${ { 0: '#2775E8', 1: '#E8A31B', 2: '#E8A31B', 3: '#E8A31B' }[row.subProjectCategory] }`"
                >
                  {{ { 0: '问卷调查', 1: '明察暗访', 2: '明察暗访', 3: '明察暗访' }[row.subProjectCategory] }}
                </span>
              </div>
              <div
                class="inline-block font-semibold text-medium text-theme-black-850 relative top-px"
                :style="{ 'margin-left': '6px', width: '600px' }"
              >
                <div v-truncate="row.subProjectTitle" class="w-full truncate"></div>
              </div>
            </div>
            
            <div class="mb-4 text-theme-black-650 text-medium">
              <span v-if="row.subProjectCategory > 0">版本：</span>
              <span v-if="row.subProjectCategory > 0" class="mr-3">{{ {1: '1.0版本', 2: '2.0版本', 3: '3.0版本'}[row.subProjectCategory] }}</span>
              <span>项目ID：</span>
              <span class="mr-3">{{ row.subProjectId }}</span>
              <span>状态：</span>
              <span>{{ row.subProjectStatusText }}</span>
            </div>
            <div class="flex text-theme-black-650 text-medium">
              <span>创建时间：</span>
              <span class="mr-3">{{ row.createTime }}</span>
              <span>更新时间：</span>
              <span>{{ row.subProjectUpdateTime }}</span>
            </div>
          </div>
          <div class="flex items-center">
            <el-divider direction="vertical" class="mx-8 text-eee"></el-divider>
            <div class="inline-block">
              <el-button type="text" v-if="!row.subProjectDeleted" @click="checkDetail(row)">查看详情</el-button>
              <el-button type="text" @click="toDelete(row)">删除</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="page.currentPage"
          :page-sizes="page.pageSizes"
          :page-size.sync="page.pageSize"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
          :pager-count="5"
          class="inline-block"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="formType === '1' ? '关联问卷调查' : '关联明察暗访'"
      :visible.sync="visible"
      width="590px"
      :append-to-body="true"
      class="theme-dialog dialog-body-0 split-line-footer-dialog"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="rules" hide-required-asterisk ref="ruleForm" label-position="left" class="overflow-auto box-border p-6 pb-1">
        <el-form-item v-if="formType === '2'" label="明察暗访版本：" label-width="110px" prop="subProjectCategory">
          <el-radio-group v-model="form.subProjectCategory">
            <el-radio label="1">1.0版本</el-radio>
            <el-radio label="2">2.0版本</el-radio>
            <el-radio label="3">3.0版本</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="项目 ID：" label-width="75px" prop="subProjectId">
          <el-input
            v-model="form.subProjectId"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <p v-if="formType === '1'" class="leading-22 text-theme-black-850 mt-3" style="padding-left: 75px;">
          <span class="text-danger mr-1 -ml-3">*</span>如何查找问卷ID：<br>
          登录调研工厂 > 进入【项目】列表 > 找到【项目ID】列 > 点击表格中 ID 即可复制成功
        </p>
        <p v-else class="leading-22 text-theme-black-850 mt-3" style="padding-left: 75px;">
          <span class="text-danger mr-1 -ml-3">*</span>如何查找明察暗访项目ID：<br>
          1.0 版：登录调研工厂 > 进入【明察暗访】列表 > 找到【项目编号】列 > 选择并复制表格中数字即可<br>
          2.0 版、3.0 版项目ID可联系开发人员咨询
        </p>
      </el-form>
      <span slot="footer" class="dialog-footer-right">
        <el-button type="primary" @click="confirm" style="width: 88px">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { relSubProject, getSubProject, cancelRelProject } from '@/api/project-task/related'

export default {
  name: 'RelatedTask',
  components: { },
  props: {
  },
  data() {
    return {
      visible: false,
      form: {
        subProjectCategory: "1"
      },
      formType: '',
      btnChecked: '',
      emptyShow: true,
      tableData: [],
      page: {
        total: 6,
        currentPage: 1,
        pageSize: 5,
        pageSizes: [5, 10, 20, 30, 50, 100]
      },
      loading: false,
      rules: {
        subProjectId: [
          { required: true, message: '请输入项目ID', trigger: 'blur' },
          // { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ]
      },
    }
  },
  watch: {},
  computed: {
    projectId() {
      return this.$route.params.id
    }
  },
  created() {
    this.getList().then(() => {
      this.emptyShow = this.tableData.length === 0
    })
    // if (this.$route.query.statementId) {
    //   this.getSettleInfo()
    // }
  },
  mounted() {},
  methods: {
    addTask(val) {
      this.formType = val
      this.visible = true
    },
    handleClose() {
      this.form = {
        subProjectCategory: "1"
      }
      this.visible = false
      this.resetForm()
    },
    confirm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const data = {
            ...this.form,
            subProjectCategory: +this.form.subProjectCategory,
            projectId: this.projectId
          }
          if(this.formType === '1') {
            data.subProjectCategory = 0
          }
          relSubProject(data).then(res=> {
            if(res.data.code !== 0 || res.data.data === false) {
              this.$message.error(res.data.msg || '关联失败')
              return
            }
            this.$message.success(res.data.msg || '关联成功')
            this.getList()
          }).catch(err=> {
            this.$message.error(err.message || '关联失败')
          }).finally(()=> {
            this.handleClose()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.$refs['ruleForm'].resetFields();
    },
    toDelete(row) {
      this.$confirm('确定删除已关联项目', '确定删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          cancelRelProject(row.id)
            .then(res => {
              if (res.data.code != 0) {
                this.$message.error(res.data.msg)
                return
              }
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            })
            .catch(err => {
              console.log(err)
            })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    checkDetail(row) {
      if(row.subProjectCategory !== 0) { //明察暗访先不跳转
        return
      }
      this.$router.push(`/survey/${row.subProjectId}/edit`)
    },
    // 获取列表
    getList() {
      const { currentPage, pageSize } = this.page
      const parmas = {
        current: currentPage,
        size: pageSize,
        projectId: this.projectId
      }
      this.loading = true
      return getSubProject(parmas)
        .then(res => {
          if (res.data.code != 0) {
            this.$message.error(res.data.msg)
            this.loading = false
            return
          }
          const list = res.data.data.records || []
          this.page.total = res.data.data.total
          this.page.currentPage = res.data.data.current
          this.page.pageSize = res.data.data.size
          this.tableData = list
          this.emptyShow = this.page.total <= 0
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.page.currentPage = 1
      this.page.pageSize = val
      this.getList()
    },
    // 切换页面 （点击页码、数字、输入数字） 触发
    currentChange(val) {
      this.page.currentPage = val
      this.getList()
    },
  },
}
</script>
<style lang="scss" scoped>
.relate-items {
  .el-button + .el-button {
    margin-left: 12px;
  }
}
.box1 {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.06);
  border-radius: 2px;
}
.box2 {
  height: calc(100% - 116px);
  overflow: auto;
}
.el-divider--vertical {
  height: 48px;
}
.btn-box {
  @apply flex justify-center items-center;
  height: 148px;
  width: 236px;
  border-radius: 4px;
  cursor: pointer;
  line-height: 16px;
  background: #F5F5F5;
  &.btn1 {
    // border: 1px solid #cccccc;
  }
  &.btn2 {
    // border: 1px solid #cccccc;
    margin-left: 72px;
  }
  &.btn1.btn-checked,
  &.btn2.btn-checked {
    border: 1px solid var(--theme-color) !important;
  }
}
.btn-checked div {
  div {
    color: var(--theme-color) !important;
  }
  i {
    color: var(--theme-color) !important;
  }
}
.btn-box:hover {
  // &.btn1,
  &.btn2 {
    border: 1px solid var(--theme-color) !important;
    div {
      div {
        color: var(--theme-color) !important;
      }
      i {
        color: var(--theme-color) !important;
      }
    }
  }
}
.disabled {
  cursor: no-drop;
  position: relative;
}
</style>
